export class Owner {
  constructor(firstName = null, ranchName = null, homeRegion = null) {
    this.id = crypto.randomUUID()
    
    // Set the name directly from the input for regular owners
    if (ranchName && homeRegion) {
      this.name = firstName;
    } 
    // Nemesis owner creation
    else {
      const nemesisNames = [
        'Blackheart', 'Weiss', 'Tseng', 'Darkwind', 'Zolom',
        'Rufus', 'Hoy', 'Joey', 'Corneo', 'Dio'
      ];
      this.name = `${firstName} ${nemesisNames[Math.floor(Math.random() * nemesisNames.length)]}`;
    }
    
    this.ranchName = ranchName
    this.homeRegion = homeRegion
    
    // Random traits (1-100)
    this.shrewdness = Math.floor(Math.random() * 100) + 1
    this.ambition = Math.floor(Math.random() * 100) + 1
    this.competitiveness = Math.floor(Math.random() * 100) + 1
    
    this.chocoboIds = []
    this.isNemesis = false
    this.money = 0 // Set by factory
  }

  toJSON() {
    return {
      id: this.id,
      name: this.name,
      ranchName: this.ranchName,
      homeRegion: this.homeRegion,
      shrewdness: this.shrewdness,
      ambition: this.ambition,
      competitiveness: this.competitiveness,
      chocoboIds: this.chocoboIds,
      isNemesis: this.isNemesis,
      money: this.money
    }
  }
}
